import { INSERT_PLUGIN_BUTTONS, TOOLBARS, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { Node_Type } from 'ricos-types';
import { D as DEFAULT_RICOS_COMPONENT_DATA, M as MEMBER_ROLES } from './helpers-d59c72d9.js';
import PollsInsertModal from './components/modals/InsertModal.js';
import { POLL_TYPE } from './types.js';
import { pollModals } from './consts.js';
import { merge } from 'lodash';
import { InsertPluginIcon } from './assets/icons/InsertPluginIcon.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'react';
import 'ricos-context';
import './components/settings/preset-selector/PollPresetSelector.js';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './style-inject.es-746bb8ed.js';
import './assets/icons/RemoveIcon.js';
import './assets/icons/ListPollIcon.js';
import './assets/icons/WithImagePollIcon.js';
import './assets/icons/GridPollIcon.js';
import 'ricos-schema';

const getAddButtons = (config, services) => {
  const componentData = merge(DEFAULT_RICOS_COMPONENT_DATA, {
    poll: { settings: { permissions: { vote: (config == null ? void 0 : config.vote) || MEMBER_ROLES.ALL } } }
  });
  return [
    {
      id: Node_Type.POLL,
      label: INSERT_PLUGIN_BUTTONS.POLLS,
      dataHook: INSERT_PLUGIN_BUTTONS.POLLS,
      icon: InsertPluginIcon,
      tooltip: "Poll_InsertPoll_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => {
        return true;
      },
      modal: {
        id: pollModals.insert,
        Component: decorateComponentWithProps(PollsInsertModal, {
          componentData,
          pluginId: POLL_TYPE
        })
      },
      menuConfig: {
        tags: "Poll_plugin_search_tags"
      }
    }
  ];
};

export { getAddButtons };
//# sourceMappingURL=getAddButtons.js.map
